// Module
var code = " <div ng-if=self.maintenanceMessage class=maintenance-bar> <span>{{self.maintenanceMessage}}</span> </div> ";
// Exports
module.exports = code;